// SCRUM-449: shared by the audience builder, the Campaigns page and the
// per-occurrence Edit, so the three editors cannot drift apart.

// Mirrors the API's TemplateVars (campaign-template.ts varsFor).
export const PLACEHOLDERS = ['parent', 'athlete', 'count', 'event', 'deadline', 'app'];

// `rsvp`/`matched`/`cart` are named exactly as the funnel cards in
// EventOps.jsx. `lead` (SCRUM-449 follow-up: per event, not global — a
// parent who signed up between the event's first day and sales close with
// no RSVP on any event) gets its own longer wording on that card; this is
// the shorter form used in the Campaigns page chips and the StagePicker. It
// is never combined with the event stages in a playbook campaign.
export const STAGE_LABELS = {
  lead: 'Signed up',
  rsvp: 'RSVPs',
  matched: 'Matched',
  cart: 'Added to cart',
};

// Promotional / urgency wording that carriers filter on toll-free SMS. A soft
// warning only — it never blocks a send.
export const SMS_WARN_WORDS = ['last chance', 'hurry', 'sale', 'discount', '%', 'free', 'deal', 'limited'];

export const LEAD_STAGE = 'lead';

export const CHANNELS = ['push', 'sms', 'email'];

export const CHANNEL_LABEL = { push: '📱 Push', sms: '💬 SMS', email: '✉ Email' };

export const CHANNEL_ICON = { push: '📱', sms: '💬', email: '✉' };

/** The SMS_WARN_WORDS present in a body, case-insensitive, in list order. */
export function smsWarnings(text) {
  const t = String(text ?? '').toLowerCase();
  return SMS_WARN_WORDS.filter((w) => t.includes(w));
}
